import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A method for estimating the Thiele and Small parameters of an electrodynamic loudspeaker is presented below. Navigate with the arrows to discover it!",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      colsSize: [1, 1],
      rowsSize: [1, 3, 1],
      colSpan: {
        "0:0": 2,
      },
      rowSpan: {
        "1:1": 2,
      },
      gap: "0 7%",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "V<sub style='text-transform:none'>as</sub> measurement: added mass method",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/19/principle/slide-7.svg`,
                },
              },
              styles: {
                paddingBottom: "10%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<ol>
                  <li>Add a mass M<sub>a</sub> on the diaphragm
                  <li>Here, mastic balls have been used
                  <li>Measure the electrical impedance for that configuration
                  <li>Then, get the value of the resonance frequency f<sub>sm</sub>
                  <li>Then, use:</br>
                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                  <msub> <mrow> <mi>V</mi> </mrow> <mrow> <mi>as</mi> </mrow> </msub>
                  <mfrac>
                  <mrow> <msub> <mrow> <mi>ρ</mi> </mrow> <mrow> <mn>0</mn> </mrow> </msub>
                  <msup> <mrow> <mi>c2</mi> </mrow> <mrow> <mn>2</mn> </mrow> </msup> <msubsup> <mrow> <mi>S</mi> </mrow> <mrow> <mi>d</mi> </mrow> <mrow> <mn>2</mn> </mrow> </msubsup></mrow>
                  <mrow> <mn>4</mn> <msup> <mrow> <mi>π</mi> </mrow> <mrow> <mn>2</mi> </mrow> </msup> <msub> <mrow> <mi>M</mi> </mrow> <mrow> <mi>a</mi> </mrow> </msub> </mrow>
                  </mfrac>
                  <mo>(</mo>
                  <mfrac>
                  <mrow> <mn>1</mn> </mrow>
                  <mrow> <msubsup> <mrow> <mi>f</mi> </mrow> <mrow> <mi>sm</mi> </mrow> <mrow> <mn>2</mn> </mrow> </msubsup> </mrow>
                  </mfrac> <mo>-</mo>
                  </mfrac>
                  <mfrac>
                  <mrow> <mn>1</mn> </mrow>
                  <mrow> <msubsup> <mrow> <mi>f</mi> </mrow> <mrow> <mi>s</mi> </mrow> <mrow> <mn>2</mn> </mrow> </msubsup> </mrow>
                  </mfrac>
                  <mo>)</mo>
                  </math>
                  </ol>`,
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
              },
            },
          },
        ],
        [],
      ],
    },
  },
};

export default principle;
